import { rejectionMessage } from '@/helpers/emailRejections.js'

/**
* Показує звіт про якість запрошення до участі в тендері для кожного електронного листа: адреси, які було відхилено
* (не запрошено) та окремо попередження про неблокування для адрес, які було прийнято.
 */
export default {
  methods: {
    /**
     * @param {Array<{email: string, reason: string, suggestion?: string}>} rejected
     * @param {Array<{email: string, reason: string}>} [warnings]
     */
    $_notifyEmailRejections(rejected, warnings = []) {
      if (rejected?.length) {
        this.$notice.warning({
          title: this.$t('EmailRejection.RejectedTitle'),
          message: rejected.map(item => rejectionMessage(item, this.$t.bind(this))).join('; '),
          showClose: true,
          progress: true,
          duration: 20
        })
      }
      if (warnings?.length) {
        this.$notice.info({
          title: this.$t('EmailRejection.WarningTitle'),
          message: warnings.map(item => rejectionMessage(item, this.$t.bind(this))).join('; '),
          showClose: true,
          progress: true,
          duration: 20
        })
      }
    }
  }
}
